/* Flair — mix V7 + V9 : défilé des nouveautés (en boucle) + pastille de taille. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Défilé en boucle : la paire au centre est mise en avant ; flèches, points, glisser, défilement auto doux.
     Les paires sont clonées avant et après (3 séries) et l'on démarre sur la série du milieu : la dernière paire
     apparaît à gauche de la première. Quand le défilement s'arrête dans une série clonée, on saute sans animation
     sur la même paire de la série du milieu (rien ne bouge à l'écran), donc on peut tourner sans fin. */
  function initDef(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('.fx-def__track');
    var orig = Array.prototype.slice.call(root.querySelectorAll('.fx-def__card')), dots = root.querySelectorAll('.fx-def__dot');
    var n = orig.length, i = 0, pos = n, timer = null, hover = false, visible = false, raf = 0, settle = 0;
    if (!track || n < 2) return;

    function clone(c) {
      var k = c.cloneNode(true);
      k.classList.remove('is-on');
      k.setAttribute('aria-hidden', 'true');
      k.tabIndex = -1;
      return k;
    }
    orig.slice().reverse().forEach(function (c) { track.insertBefore(clone(c), track.firstChild); });
    orig.forEach(function (c) { track.appendChild(clone(c)); });
    var cards = Array.prototype.slice.call(track.querySelectorAll('.fx-def__card'));

    function setOn(p) {
      pos = p;
      cards.forEach(function (c, j) { c.classList.toggle('is-on', j === p); });
      i = ((p % n) + n) % n;
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }
    function nearest() {
      var mid = track.getBoundingClientRect().left + track.clientWidth / 2, best = 0, bd = Infinity;
      cards.forEach(function (c, j) {
        var r = c.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bd) { bd = d; best = j; }
      });
      return best;
    }
    function center(p, smooth) {
      var cr = cards[p].getBoundingClientRect(), tr = track.getBoundingClientRect();
      var left = track.scrollLeft + (cr.left + cr.width / 2) - (tr.left + track.clientWidth / 2);
      track.scrollTo({ left: left, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    }
    function go(p) {
      p = Math.max(0, Math.min(cards.length - 1, p));
      center(p, true);
      setOn(p);
    }
    /* retour discret sur la série du milieu */
    function recenter() {
      if (pos >= n && pos < 2 * n) return;
      var p = n + i;
      root.classList.add('fx-def--jump');
      track.style.scrollSnapType = 'none';
      center(p, false);
      setOn(p);
      requestAnimationFrame(function () {
        track.style.scrollSnapType = '';
        requestAnimationFrame(function () { root.classList.remove('fx-def--jump'); });
      });
    }
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setOn(nearest()); });
      clearTimeout(settle);
      settle = setTimeout(recenter, 180);
    }, { passive: true });

    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (reduce || root.dataset.autoplay !== 'true' || hover || !visible) return;
      timer = setInterval(function () { go(pos + 1); }, 5000);
    }
    var next = root.querySelector('[data-next]'), prev = root.querySelector('[data-prev]');
    if (next) next.addEventListener('click', function () { go(pos + 1); start(); });
    if (prev) prev.addEventListener('click', function () { go(pos - 1); start(); });
    /* un point : la même paire dans la série courante */
    dots.forEach(function (d) { d.addEventListener('click', function () { go(pos - i + parseInt(d.getAttribute('data-i'), 10)); start(); }); });
    /* une carte voisine cliquée : on la centre au lieu d'ouvrir la page */
    cards.forEach(function (c, j) {
      c.addEventListener('click', function (e) { if (j !== pos) { e.preventDefault(); go(j); start(); } });
    });
    track.addEventListener('pointerdown', stop);
    track.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('mouseenter', function () { hover = true; stop(); });
    root.addEventListener('mouseleave', function () { hover = false; start(); });
    root.addEventListener('focusin', stop);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; visible ? start() : stop(); }, { threshold: .4 }).observe(root);
    }
    window.addEventListener('resize', function () { center(pos, false); });
    root.classList.add('fx-def--jump');
    center(n, false);
    setOn(n);
    requestAnimationFrame(function () { root.classList.remove('fx-def--jump'); });
  }

  /* Taille : une pastille glisse sous la taille choisie (placée hors de la liste pour ne pas gêner le thème) */
  function initSizes() {
    document.querySelectorAll('.product-form__option-selector[data-selector-type="block"] .block-swatch-list').forEach(function (list) {
      var host = list.parentElement;
      if (!host || host.querySelector(':scope > .fx-ind')) return;
      host.style.position = 'relative';
      var ind = document.createElement('span');
      ind.className = 'fx-ind';
      ind.setAttribute('aria-hidden', 'true');
      host.insertBefore(ind, list);
      function place() {
        var c = list.querySelector('.block-swatch__radio:checked');
        var item = c ? c.parentElement.querySelector('.block-swatch__item') : null;
        if (!item) { ind.style.opacity = '0'; return; }
        var hr = host.getBoundingClientRect(), ir = item.getBoundingClientRect();
        if (!ir.width) { ind.style.opacity = '0'; return; }
        ind.style.opacity = '1';
        ind.style.left = '0'; ind.style.top = '0';
        ind.style.width = ir.width + 'px'; ind.style.height = ir.height + 'px';
        ind.style.transform = 'translate(' + (ir.left - hr.left) + 'px,' + (ir.top - hr.top) + 'px)';
      }
      list.addEventListener('change', function () { setTimeout(place, 0); });
      window.addEventListener('resize', place);
      setTimeout(place, 50);
    });
  }

  /* « ☰ Menu » sur ordinateur : grand panneau avec tout le menu visible (2 clics max).
     Ne pas toucher aria-expanded du bouton : le thème ouvrirait aussi son tiroir. */
  var desk = window.matchMedia('(min-width: 1000px)');
  function panel() { return document.getElementById('fm-menu-panel'); }
  function burger() { return document.querySelector('.header [aria-controls="mobile-menu-drawer"]'); }
  function openPanel() {
    var p = panel(), h = document.querySelector('.shopify-section--header') || document.querySelector('.header');
    if (!p) return;
    p.style.setProperty('--fm-top', Math.max(0, h ? h.getBoundingClientRect().bottom : 0) + 'px');
    p.hidden = false;
    document.documentElement.classList.add('fm-mp-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.add('is-open'); }); });
    var first = p.querySelector('a'); if (first) first.focus({ preventScroll: true });
  }
  function closePanel() {
    var p = panel();
    if (!p || p.hidden) return;
    p.classList.remove('is-open');
    document.documentElement.classList.remove('fm-mp-open');
    setTimeout(function () { if (!p.classList.contains('is-open')) p.hidden = true; }, reduce ? 0 : 320);
  }
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[aria-controls="mobile-menu-drawer"]');
    if (b && desk.matches && panel() && b.closest('.header')) {
      e.preventDefault(); e.stopImmediatePropagation();
      panel().hidden ? openPanel() : closePanel();
      return;
    }
    if (e.target.closest && e.target.closest('[data-fm-mp-close]')) closePanel();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
  desk.addEventListener && desk.addEventListener('change', closePanel);

  /* Menu téléphone : le nom ouvre la collection, seul le + déplie ; Sneakers déjà ouvert */
  function splitMobileNav() {
    var mapEl = document.getElementById('fm-menu-map'), map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    document.querySelectorAll('#mobile-menu-drawer button.mobile-nav__link[aria-controls]').forEach(function (b) {
      if (b.dataset.fmTitle) return;
      var li = b.closest('.mobile-nav__item'), title = '';
      b.childNodes.forEach(function (n) { if (n.nodeType === 3) title += n.textContent; });
      title = title.trim();
      var key = title;
      if (li.getAttribute('data-level') === '2') {
        var p = li.parentElement.closest('.mobile-nav__item[data-level="1"]');
        var pt = p && p.querySelector(':scope > [data-fm-title]');
        key = (pt ? pt.dataset.fmTitle : '') + '>' + title;
      }
      var url = map[key];
      if (!url) return;
      var a = document.createElement('a');
      a.href = url; a.className = b.className; a.textContent = title; a.dataset.fmTitle = title;
      li.insertBefore(a, b);
      li.classList.add('fm-mn-split');
      b.dataset.fmTitle = title;
      b.childNodes.forEach(function (n) { if (n.nodeType === 3) n.textContent = ''; });
      b.setAttribute('aria-label', 'Afficher ' + title);
      b.classList.add('fm-mn-toggle');
    });
  }
  var sneakersOpened = false;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.header [aria-controls="mobile-menu-drawer"]');
    if (!b || desk.matches || sneakersOpened) return;
    sneakersOpened = true;
    setTimeout(function () {
      var t = document.querySelector('#mobile-menu-drawer .mobile-nav__item[data-level="1"] > button.fm-mn-toggle[data-fm-title="Sneakers"]');
      if (t && t.getAttribute('aria-expanded') === 'false') t.click();
    }, 0);
  });

  /* Téléphone : le titre de collection rétrécit jusqu'à tenir sur une ligne */
  function fitTitles() {
    document.querySelectorAll('.fm-bn__title').forEach(function (h) {
      h.style.fontSize = ''; h.style.whiteSpace = '';
      if (window.innerWidth > 740) return;
      var txt = h.querySelector('.fm-mask > span') || h, size = parseFloat(getComputedStyle(h).fontSize), guard = 0;
      h.style.whiteSpace = '';
      while (txt.getBoundingClientRect().width > h.clientWidth + 1 && size > 24 && guard++ < 40) {
        size -= 1; h.style.fontSize = size + 'px';
      }
      /* titre trop long même en petit : on le laisse passer à la ligne plutôt que de le couper */
      if (txt.getBoundingClientRect().width > h.clientWidth + 1) { h.style.whiteSpace = 'normal'; h.style.fontSize = '26px'; }
    });
  }
  window.addEventListener('resize', fitTitles);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitles);

  function init() {
    fitTitles();
    document.querySelectorAll('[data-fx-def]').forEach(initDef);
    initSizes();
    splitMobileNav();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:changed', function () { setTimeout(initSizes, 30); });
})();
